import React from 'react';
import './ProgressBar.css';

interface ProgressBarProps {
  progress: number;
  showText?: boolean;
  className?: string;
}

const ProgressBar: React.FC<ProgressBarProps> = ({ 
  progress, 
  showText = true,
  className = '' 
}) => {
  const percentage = Math.min(Math.max(progress || 0, 0), 100);

  return (
    <div className={`progress-bar-container ${className}`}>
      <div className="progress-bar">
        <div 
          className="progress-fill" 
          style={{ width: `${percentage}%` }}
        />
      </div>
      {showText && (
        <span className="progress-text">{percentage}% complete</span>
      )}
    </div>
  );
};

export default ProgressBar;

